import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import CreditInfo from "@components/CreditInfo/CreditInfo";
import { history } from "@helpers/history";
import { isObjEmpty } from "@helpers/utils";

const BORDER_TOP_COLOR = "#d7de00";

function CreditosPersonales(props) {
  const {
    match: { params },
  } = props;
  const [idCredito, setIdCredito] = useState("");
  const [credit, setCredit] = useState({});

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { creditosPersonales } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    setIdCredito(params?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const defRoute = rutas?.filter(
      (route) => route?.name === "Creditos Personales Listado"
    );

    const prevRoute = defRoute.map((route) => {
      return {
        url: route.url.replace("/:id", ""),
        text: route.h1,
      };
    });

    if (!isEmpty(idCredito) && !isEmpty(creditosPersonales)) {
      let promise = new Promise((resolve, reject) => {
        let normalizeCredits = [];
        let resMatch = {};
        if (!isEmpty(creditosPersonales?.aCCreditosPersonales)) {
          normalizeCredits = creditosPersonales.aCCreditosPersonales.map(
            (credito) => ({
              ...credito,
              idCredito: credito.idCredito.toLowerCase().replaceAll(" ", "-"),
              rutaPrevia: prevRoute,
            })
          );
          resMatch =
            normalizeCredits &&
            normalizeCredits.filter(
              (credito) => credito.idCredito === idCredito
            )[0];
        }
        if (
          !isEmpty(creditosPersonales?.aCCreditosPersonales) &&
          !isEmpty(creditosPersonales?.aCBotonSoliciteSuCredito)
        ) {
          resMatch = {
            ...resMatch,
            btnSolicite: {
              images: creditosPersonales.aCBotonSoliciteSuCredito[0],
              url: resMatch?.urlFormularioSoliciteCredito?.url,
              alt: resMatch?.urlFormularioSoliciteCredito?.text,
            },
          };
        }
        if (
          !isEmpty(creditosPersonales?.aCCreditosPersonales) &&
          !isEmpty(creditosPersonales?.aCBotonCalculesuCredito)
        ) {
          resMatch = {
            ...resMatch,
            btnCalcule: {
              images: creditosPersonales.aCBotonCalculesuCredito[0],
              url: "/",
              alt: "Calcule su Crédito",
            },
          };
        }
        resolve(resMatch);
      });

      promise.then((res) => { 
        !isUndefined(res.btnSolicite.url) && !isEmpty(res)
          ? setCredit({
              id: res.idCredito,
              title: res.titulo,
              description: res.descripcion?.html,
              details: res.bag?.contentItems,
              btnSolicite: res.btnSolicite,
              btnCalcule: res.btnCalcule,
              prevRoute: res.rutaPrevia,
            })          
          : isObjEmpty(credit) && history.push('/no-encontrado')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [creditosPersonales, idCredito]); 

  return (
    <>
      {!isEmpty(credit) && (
        <CreditInfo credito={credit} borderTopColor={BORDER_TOP_COLOR} />
      )}
    </>
  );
}

export default CreditosPersonales;
